import React, { Component, Fragment } from 'react';
import { Dialog, TableHead, DialogTitle, DialogContent, Typography, IconButton, Grid, Divider, Table, TableBody, TableRow, TableCell, Box, Button } from '@mui/material';
import Currency from '../../common/Currency';
import { ArrowBack } from '@mui/icons-material';
import { isEmpty } from "lodash"
import { extension } from 'mime-types'
import SpendingDetails from '../../Spendings/SpendingDetails';
import { orderByDateAsc } from '../../../store/actions/format';

class CreditDetails extends Component {
    state = { 
        payments: [],
        openSpending: false,
        spending: {},
        fetched: false,
        subCredits: [],
        subCreditsFetched: false,
        spendingDemands: {} // Stocker les spending demands récupérées par ID
    }

    componentDidMount = () => {
        // Récupérer les sous-avances si le crédit est disponible
        if (this.props.credit && this.props.credit.credit_id) {
            this.fetchSubCredits()
        }
    }

    componentDidUpdate = (prevProps) => {
        // Récupérer les sous-avances si le crédit change
        if (this.props.credit && this.props.credit.credit_id && 
            (!prevProps.credit || prevProps.credit.credit_id !== this.props.credit.credit_id)) {
            this.fetchSubCredits()
        }
    }

    getSpendingDemandLabel = (spendingDemandId) => {
        if (!spendingDemandId) {
            return "-";
        }

        // Utiliser les données récupérées depuis le backend
        const demand = this.state.spendingDemands[spendingDemandId];

        if (demand && typeof demand === "object") {
            return (
                demand.spending_demand_name ||
                demand.spending_demand_desc ||
                demand.spending_demand_title ||
                demand.spending_demand_reference ||
                spendingDemandId
            );
        }

        // Fallback: utiliser les données du store si disponibles
        const { SPENDING_DEMANDS } = this.props;
        const storeDemand = SPENDING_DEMANDS ? SPENDING_DEMANDS[spendingDemandId] : null;

        if (storeDemand && typeof storeDemand === "object") {
            return (
                storeDemand.spending_demand_name ||
                storeDemand.spending_demand_desc ||
                storeDemand.spending_demand_title ||
                storeDemand.spending_demand_reference ||
                spendingDemandId
            );
        }

        return spendingDemandId;
    }

    fetchSubCredits = async () => {
        if (!this.props.credit || !this.props.credit.credit_id) return
        
        try {
            const result = await this.props.fetchSubCredits(this.props.credit.credit_id)
            if (result && result.data) {
                this.setState({
                    subCredits: result.data,
                    subCreditsFetched: true
                })
                
                // Récupérer les spending demands pour chaque sous-avance
                this.fetchSpendingDemands(result.data)
            }
        } catch (error) {
            console.error("[ERROR] Failed to fetch sub-credits:", error)
            this.setState({
                subCredits: [],
                subCreditsFetched: true
            })
        }
    }

    fetchSpendingDemands = async (subCredits) => {
        if (!subCredits || !Array.isArray(subCredits)) return
        
        // Collecter tous les IDs de spending demands uniques
        const spendingDemandIds = [...new Set(
            subCredits
                .map(subCredit => subCredit.s_credit_spending_demand)
                .filter(id => id && id !== "")
        )]
        
        if (spendingDemandIds.length === 0) return
        
        // Récupérer chaque spending demand
        const spendingDemands = {}
        const promises = spendingDemandIds.map(async (id) => {
            try {
                const demand = await this.props.fetchSingleSpendingDemand(id)
                if (demand) {
                    spendingDemands[id] = demand
                }
            } catch (error) {
                console.error(`[ERROR] Failed to fetch spending demand ${id}:`, error)
            }
        })
        
        await Promise.all(promises)
        
        // Mettre à jour le state avec les spending demands récupérées
        this.setState(prevState => ({
            spendingDemands: {
                ...prevState.spendingDemands,
                ...spendingDemands
            }
        }))
    }

    // CREDIT => PAYMENTS => PAYMENT_DETAILS => SPENDING
    findPayments = () => {
        const { PAYMENT_DETAILS, PAYMENTS, SPENDINGS, CATEGORIES, DEBITS, credit } = this.props;
        let payments = []

        let list = Object.values(PAYMENTS).filter( pay => pay.payment_credit === credit.credit_id && !pay.is_avance)
        list.forEach( pay => {
            Object.values(PAYMENT_DETAILS).forEach( item => {
                if (item.payment_info_id === pay.payment_id){
                    let spending =  SPENDINGS[item.payment_spending_id]
                    let category =  CATEGORIES.CHILD[spending.spending_category]
                    let categoryParent =  CATEGORIES.PARENT[category.category_parent].category_name
                    item.date = spending.spending_date
                    let payDetail = Object.assign({spending, category, categoryParent}, item)
                    payments.push(payDetail)
                }
            })
        })
        let debits = Object.values(DEBITS).filter( deb => deb.credit_src === credit.credit_id)
        debits.forEach( debit => {
            payments.push({
                payment_info_id: debit.credit_id,
                payment_details_user: debit.credit_user,
                payment_amount: debit.credit_amount,
                payment_details_credit: debit.credit_src,
                // payment_is_supplier_advance:false,
                // payment_details_supplier:"",
                // payment_details_advance:"",
                date: debit.credit_creation_date,
                payment_details_bank: debit.credit_bank,
                payment_details_mode: debit.credit_payment_mode,
                payment_details_ref: debit.credit_ref,
                type:"debit",
            })
        })
        
        payments = orderByDateAsc(payments, "date")

        console.log('====================================');
        console.log({payments});
        console.log('====================================');
        this.setState({
            fetched: true,
            payments
        })
    }

    render() {
        const { credit, USERS, BANKS, PAYMENT_DETAILS, SPENDINGS, SUPPLIERS, LABELS, PAYMENTS, CATEGORIES } = this.props
        const { payments, openSpending, spending, fetched } = this.state;

        // if ( !isEmpty(PAYMENT_DETAILS) && !isEmpty(SPENDINGS) && isEmpty(payments) ) {
        if (  !fetched && !isEmpty(PAYMENT_DETAILS) && !isEmpty(SPENDINGS)) {
            this.findPayments()
        }
        return (
            <Dialog
                // disableBackdropClick
                open={true}
                // onClose={this.props.handleClose}
                onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                aria-labelledby="form-dialog-title"
                maxWidth="lg"
                fullWidth
                scroll="paper"
                sx={{ zIndex: 13000 }}
                PaperProps={{ sx: { zIndex: 13000 } }}
            >
                {openSpending && spending && 
                    <SpendingDetails 
                        supplier={SUPPLIERS && SUPPLIERS[spending.spending_supplier]} 
                        LABELS={LABELS}
                        BANKS={BANKS}
                        PAYMENTS={PAYMENTS}
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[spending.spending_category]} 
                        spending={spending} 
                        view="ADMIN"
                        handleClose={()=> this.setState({ openSpending: false, spending: {} })}
                        fetchSpendingPayments={this.props.fetchSpendingPayments}
                    />
                }
                <DialogTitle >
                    <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
                        <ArrowBack /> 
                    </IconButton>
                    Credit n° {credit.credit_ref}
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {/* <Typography variant="h6" style={{textAlign: "center"}}><Currency value={credit.credit_amount} /></Typography>
                    <Divider /> */}
                    <Grid container spacing={2} style={{marginTop: "20px"}}>
                        <Grid item xs={12} sm={6}>
                            
                            <Table className="table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Montant</Typography></TableCell>
                                        <TableCell><Currency value={credit.credit_amount} /></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Restant</Typography></TableCell>
                                        <TableCell><Currency value={credit.credit_total_available} /></TableCell>
                                    </TableRow>
                                    
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Utilisateur</Typography>
                                        </TableCell>
                                        <TableCell>{credit.credit_user_id && USERS[credit.credit_user_id] && USERS[credit.credit_user_id].email}</TableCell>
                                    </TableRow>
                                    
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Payé le:</Typography>
                                        </TableCell>
                                        <TableCell>{new Date(credit.credit_creation_date).toLocaleDateString("fr-FR")}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell> 
                                            <Typography variant="button">Banque</Typography>
                                        </TableCell>
                                        <TableCell>
                                            {credit.credit_bank && BANKS[credit.credit_bank] && BANKS[credit.credit_bank].bank_name}
                                        </TableCell>
                                    </TableRow>
                                    
                                    
                                </TableBody>
                            </Table>
                            
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            {credit.credit_files &&
                                <Grid container spacing={3}>
                                    {credit.credit_files.map( (photo, index) => (
                                        <Fragment>
                                            {photo.filetype === "application/pdf" &&
                                                <Grid key={photo.filename} item xs={12} >
                                                    <a href={`/photos/${photo.filename}`} 
                                                        download={`fichier${index + 1}.${ extension(photo.filetype) || "pdf"}`}
                                                    >
                                                        <embed 
                                                            src={`/photos/single/${photo.filename}`} 
                                                            width="100%" 
                                                            height="400px" 
                                                            title={`fichier${index + 1}`} 
                                                            type="application/pdf"
                                                        />
                                                    </a>
                                                </Grid>
                                            }

                                            {photo.filetype !== "application/pdf" &&
                                                <Grid key={photo.filename} item xs={6} >
                                                    <a href={`/photos/${photo.filename}`} 
                                                        download={`fichier${index + 1}.${ extension(photo.filetype) || "pdf"}`}
                                                    >
                                                        <img 
                                                            src={`/photos/single/${photo.filename}`} 
                                                            title={`fichier${index + 1}`} 
                                                            alt={`fichier${index + 1}`} 
                                                        />
                                                    </a>
                                                </Grid>
                                            }
                                        </Fragment>                          
                                        )) }
                                </Grid>
                            }
                

                        </Grid>
                        
                    </Grid>
                    <Divider />
                    {this.state.subCreditsFetched && this.state.subCredits.length > 0 && (
                        <>
                            <Box mt={3} mb={2}>
                                <Typography variant="h6" style={{fontWeight: "700", marginBottom: "10px"}}>
                                    Sous-avances
                                </Typography>
                            </Box>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{fontWeight: "700"}}>Montant</TableCell>
                                        <TableCell style={{fontWeight: "700"}}>Description</TableCell>
                                        <TableCell style={{fontWeight: "700"}}>Demande de dépense</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.subCredits.map((subCredit) => (
                                        <TableRow key={subCredit.s_credit_id || subCredit.s_credit_src}>
                                            <TableCell>
                                                <Currency value={subCredit.s_credit_amount} />
                                            </TableCell>
                                            <TableCell>
                                                {subCredit.s_credit_desc || "-"}
                                            </TableCell>
                                            <TableCell>
                                                {subCredit.s_credit_spending_demand && subCredit.s_credit_spending_demand !== "" ? (
                                                    <Button 
                                                        onClick={() => {
                                                            window.location.href = `/admin/spendings_demand?spending_demand_id=${subCredit.s_credit_spending_demand}`
                                                        }}
                                                        style={{ textTransform: 'none', padding: 0, minWidth: 'auto' }}
                                                    >
                                                        {this.getSpendingDemandLabel(subCredit.s_credit_spending_demand)}
                                                    </Button>
                                                ) : (
                                                    "-"
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                            <Divider style={{marginTop: "20px", marginBottom: "20px"}} />
                        </>
                    )}
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={3} style={{textAlign: "center", fontWeight: "700"}}>Dépenses</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {payments && payments.map(pay => (
                                    pay.type !== "debit" ? 
                                    (<TableRow
                                        hover
                                        className="clickable" 
                                        key={pay.payment_info_id} 
                                        onClick={ () => this.setState({ 
                                            openSpending: true, 
                                            spending: pay.spending 
                                        }) }
                                    >
                                        <TableCell>
                                            {new Date(pay.spending.spending_date).toLocaleDateString("fr-FR")}
                                        </TableCell>
                                        <TableCell>
                                            <b>{pay.category.category_name}</b> - <i>{pay.categoryParent}</i>
                                        </TableCell>
                                        <TableCell><Currency value={pay.payment_amount} /></TableCell>
                                    </TableRow>)
                                    :
                                    (<TableRow
                                        hover
                                        // className="clickable" 
                                        style={{backgroundColor: "cornsilk"}}
                                        key={pay.payment_info_id} 
                                        // onClick={ () => this.setState({ 
                                        //     openSpending: true, 
                                        //     spending: pay.spending 
                                        // }) }
                                    >
                                        <TableCell>
                                            {new Date(pay.date).toLocaleDateString("fr-FR")}
                                        </TableCell>
                                        <TableCell>
                                            <b>Retour sur Avance</b>
                                        </TableCell>
                                        <TableCell><Currency value={pay.payment_amount} /></TableCell>
                                    </TableRow>)
                                ))
                            }

                        </TableBody>
                    </Table>
                    
                </DialogContent>
            </Dialog>
        );
    }
}

export default CreditDetails;